import type { LabelConfig } from '@repo/sdk/models/components';

import { parseBannerSubText } from '@/features/equipment-browser/animatics/animatics.helpers';
import { useGetRefValue } from '@/readings-settings/use-get-ref-value';

/**
 * Live fault reason: the value of the faulted animatic banner's ref, formatted
 * exactly like the banner's sub-label on the equipment card. Undefined when the
 * device has no banner or no value yet.
 */
export const useFaultReason = (faultReasonLabel: LabelConfig | undefined): string | undefined => {
  // Subscribes the caller to the ref so the formatted text below stays current.
  useGetRefValue(faultReasonLabel?.ref);

  if (!faultReasonLabel) return undefined;
  return parseBannerSubText(faultReasonLabel) || undefined;
};
